import * as React from "react";
import { useState } from "react";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { AiOutlineClose } from "react-icons/ai";
import { Slide } from "@mui/material";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { auth } from "./firebase";
import { provider } from "./firebase";
import { GoogleAuthProvider } from "firebase/auth";
import { signInWithGoogle } from "./firebase";

export default function LoginForm({ language, isOpen, isClose }) {
  const [open, setOpen] = useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    console.log("halwa");
    console.log(open);
    // onClose(); // Call the onClose function
  };
 

  const [email, setEmail] = useState("");
  const [pass, setPass] = useState("");
  const [displayName, setDisplayName] = useState("");

  const onSubmit = () => {
    signInWithEmailAndPassword(auth, email, pass, displayName)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        setDisplayName(user.displayName);
        console.log(user.displayName);
        handleClose();
        // ...
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);
        alert(errorMessage);
      });
  };

  return (
    <div>
      {language === "en" && (
        <button
          onClick={handleClickOpen}
          className="pl-1 mt-1 text-gray-500 hover:text-orange-500"
          type="submit"
        >
          {" "}
          Login
        </button>
      )}
      {language === "hi" && (
        <button
          onClick={handleClickOpen}
          className="pl-1 mt-1 text-gray-500 hover:text-orange-500"
          type="submit"
        >
          {" "}
          लॉगिन
        </button>
      )}
      <div>
        <div className="hidden sm:inline-block">
          <Dialog
            open={open || isOpen}
            onClose={isClose}
            transitionDuration={700}
            TransitionComponent={Slide}
            className={`scale-110 ${
              "w-screen h-screen"
            } md:scale-100`}
          >
            <div className="flex flex-col md:flex-row">
              <div className="flex border-2 md:w-[40%]">
                <div className="flex md:flex-col justify-between md:w-1/2">
                  <div></div>
                  <div></div>
                  <div className="flex items-center">
                    <p className="p-8 scale-75 bg-orange-500 rounded-full text-3xl text-white px-11">
                      S
                    </p>
                  </div>
                  <div className="pl-10">
                    <div className="md:space-y-3 space-y-1">
                      <p className="text-xl">Log In</p>
                      <button onClick={isClose}>
                        <AiOutlineClose />
                      </button>
                      <div className="md:hidden"></div>
                      <hr className="border-1 w-[90%]" />
                      {language === "en" && (
                        <p className="flex flex-wrap w-[80%] text-black">
                          Get access to your Orders, Wishlist and
                          Recommendations.
                        </p>
                      )}
                      {language === "hi" && (
                        <p className="flex flex-wrap w-[80%]">
                          अपनी आर्डर्स, विशलिस्ट और सिफारिशों का एक्सेस प्राप्त
                          करें।
                        </p>
                      )}
                    </div>
                  </div>
                  <div></div>
                  <div></div>
                  <div></div>
                </div>
              </div>
              <div className="flex flex-col justify-between md:w-1/2">
                {/* <DialogContent className="flex justify-end w-[120%] text-gray-400 hidden md:inline-block">
                  <button
                    onClick={handleClose}
                    className="hover:text-white hover:bg-red-600 rounded-md hover:rounded-md transition ease-in-out duration-300 flex justify-end"
                  >
                    <AiOutlineClose />
                  </button>
                </DialogContent> */}
                <DialogContent className="space-y-6 md:w-[120%]">
                  <TextField
                    // autoFocus
                    margin="dense"
                    id="name"
                    label="Email ID"
                    type="email"
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    variant="standard"
                    required={true}
                    minlength={100000000}
                    maxlength={9999999999}
                  />
                  <div className="relative">
                    <TextField
                      // autoFocus
                      margin="dense"
                      id="password"
                      label="Password"
                      onChange={(e) => setPass(e.target.value)}
                      type="text"
                      fullWidth
                      variant="standard"
                      required={true}
                    />
                    {/* <button className="absolute transition ease-in-out duration-300 right-0 bottom-2 text-blue-400 hover:bg-gray-100 px-1">
                  Forgot?
                </button> */}
                  </div>
                </DialogContent>
                <DialogContent className="flex flex-col space-y-4 w-[120%]">
                  {language === "en" && (
                    <button
                      onClick={onSubmit}
                      className="px-2 py-1 bg-orange-500 rounded-sm text-white font-semibold shadow-md hover:bg-orange-400 transition ease-in-out duration-300"
                    >
                      Log In
                    </button>
                  )}
                  {language === "hi" && (
                    <button
                      onClick={onSubmit}
                      className="px-2 py-1 bg-orange-500 rounded-sm text-white font-semibold shadow-md hover:bg-orange-400 transition ease-in-out duration-300"
                    >
                      {" "}
                      लॉग इन करें।
                    </button>
                  )}
                  {/* <div className="flex flex-row justify-between items-center">
                <hr className="border-1 w-[40%]" />
                <p>OR</p>
                <hr className="border-1 w-[40%]" />
              </div>
              <button className="px-2 py-1 bg-orange-500 rounded-sm text-white font-semibold shadow-md hover:bg-orange-400 transition ease-in-out duration-300">
                Login with OTP
              </button> */}
                  <div className="flex justify-center flex-col space-y-2">
                    {/* <button className="transition ease-in-out duration-500 right-0 bottom-2 text-blue-400 hover:bg-gray-100 px-1">
                  Don't have an account? Sign Up
                </button> */}
                    <div className="flex justify-center border-2 rounded-xl hover:shadow-lg hover:shadow-cyan-200 hover:bg-gray-700 transition ease-in-out duration-300 text-white bg-gray-800">
                      <img
                        src="https://img.icons8.com/color/48/000000/google-logo.png"
                        className="scale-75"
                      />
                      {language === "en" && (
                        <button onClick={signInWithGoogle} className="bottom-0">
                          Sign In With Google
                        </button>
                      )}
                      {language === "hi" && (
                        <button onClick={signInWithGoogle} className="bottom-0">
                          गूगल के साथ साइन इन करें।
                        </button>
                      )}
                    </div>
                  </div>
                </DialogContent>
                <DialogContent className="mb-2" />
              </div>
            </div>
          </Dialog>
        </div>

        {/* Mobile View */}
        <div className="sm:hidden">
          <Dialog
            open={open ||  isOpen}
            onClose={handleClose}
            transitionDuration={700}
            TransitionComponent={Slide}
          >
            <DialogContent className="flex absolute right-0 top-0 text-gray-400">
                <button
                  onClick={isClose || handleClose}
                  className="hover:text-white hover:bg-green-600 rounded-md hover:rounded-md transition ease-in-out duration-300 flex justify-end"
                >
                  <AiOutlineClose />
                </button>
              </DialogContent>
            <div className="flex flex-col md:flex-row ">
              <div className="flex border-2 md:w-[40%] pb-4">
                <div className="flex md:flex-col justify-between items-center">
                  <div></div>
                  <div className="flex items-center">
                    <p className="p-8 scale-75 bg-orange-500 rounded-full text-3xl text-white px-11">
                      S
                    </p>
                  </div>
                  <div className="pl-6 pt-10 md:pt-2">
                    <div className="md:space-y-3 space-y-1">
                      <p className="text-xl">Log In</p>
                      <hr className="border-1 w-[90%]" />
                      <p className="flex flex-wrap w-[80%] text-black">
                        Get access to your Orders, Wishlist and Recommendations.
                      </p>
                    </div>
                  </div>
                  <div className="hidden md:inline-block"></div>
                  <div className="hidden md:inline-block"></div>
                  <div className="hidden md:inline-block"></div>
                </div>
              </div>
              <div className="flex flex-col justify-between md:w-1/2">
                <DialogContent className="space-y-6 md:w-[100%]">
                  <TextField
                    // autoFocus
                    margin="dense"
                    id="name"
                    label="Email ID"
                    type="email"
                    onChange={(e) => setEmail(e.target.value)}
                    fullWidth
                    variant="standard"
                    required={true}
                    minlength={100000000}
                    maxlength={9999999999}
                  />
                  <div className="relative">
                    <TextField
                      // autoFocus
                      margin="dense"
                      id="password"
                      label="Password"
                      onChange={(e) => setPass(e.target.value)}
                      type="text"
                      fullWidth
                      variant="standard"
                      required={true}
                    />
                    {/* <button className="absolute transition ease-in-out duration-300 right-0 bottom-2 text-blue-400 hover:bg-gray-100 px-1">
                  Forgot?
                </button> */}
                  </div>
                </DialogContent>
                <DialogContent className="flex flex-col space-y-4 w-[100%]">
                  <button
                    onClick={onSubmit}
                    className="px-2 py-1 bg-orange-500 rounded-sm text-white font-semibold shadow-md hover:bg-orange-400 transition ease-in-out duration-300"
                  >
                    Log In
                  </button>

                  <div className="flex justify-center flex-col space-y-2">
                    <div className="flex justify-center border-2 rounded-xl hover:shadow-lg hover:shadow-cyan-200 hover:bg-gray-700 transition ease-in-out duration-300 text-white bg-gray-800">
                      <img
                        src="https://img.icons8.com/color/48/000000/google-logo.png"
                        className="scale-75"
                      />
                      <button onClick={signInWithGoogle} className="bottom-0">
                        Sign In With Google
                      </button>
                    </div>
                  </div>
                </DialogContent>
                <DialogContent className="mb-2" />
              </div>
            </div>
          </Dialog>
        </div>
      </div>
    </div>
  );
}
